<template>
    <single-line-text-input
        ref="input"
        v-model="internalValue"
        :placeholder="$t('placeholder-enter-url')"
    ></single-line-text-input>
</template>

<script>
import CustomQuestion from '@/mixins/CustomQuestion';

export default {
    name: 'FormWebUrlQuestion',

    mixins: [CustomQuestion],

    computed: {
        namespace () {
            return 'webUrl';
        }
    },

    methods: {
        focus () {
            this.$refs.input.focus();
        }
    }
};
</script>
